exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-section[data-v-24e41142]{padding:20px 0;text-align:center;background:#ececec}@media (min-width:1025px){.title-section[data-v-24e41142]{padding:40px 0}}.title-section h1[data-v-24e41142]{margin:0;font-size:18px;font-weight:700;text-align:center;text-transform:uppercase;line-height:21px;color:#000}@media (min-width:1025px){.title-section h1[data-v-24e41142]{font-size:30px;line-height:36px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24e41142","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/PageTitle.vue
// module id = bfOz
// module chunks = 1